export default "__VITE_ASSET__5bb85b7d__"